import {
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Avatar,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Dashboard as DashboardIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const FeatureComponents = () => {
  const { t } = useTranslation();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const theme = useTheme();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const features = [
    {
      key: "wage",
      iconSrc: "/assets/icon/wage-connect.png",
      color: "warning",
      url: "dashboard/wage-connect",
    },
    {
      key: "task",
      iconSrc: "/assets/icon/tc-icon.png",
      color: "info",
      url: "dashboard/task-connect",
    },
  ];

  return (
    <>
      {" "}
      <Typography
        variant="h5"
        sx={{
          mb: 3,
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <DashboardIcon color="primary" /> {t("Dashboard.features.sectionTitle")}
      </Typography>
      <Grid
        container
        spacing={3}
        columns={{ xs: 4, sm: 8, md: 12 }}
        sx={{ mb: 6 }}
      >
        {features.map((feature, index) => (
          <Grid
            key={index}
            sx={{
              gridColumn: {
                xs: "span 4",
                sm: "span 4",
                md: "span 4",
              },
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Card
              sx={{
                width: "100%",
                maxWidth: 300,
                aspectRatio: "1 / 1", // Sama tinggi dan lebar
                borderRadius: 3,
                transition: "transform 0.3s, box-shadow 0.3s",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
                },
              }}
            >
              <CardContent
                sx={{
                  p: { xs: 2, sm: 3 },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <img
                  src={feature.iconSrc}
                  alt={feature.key}
                  style={{
                    width: 56,
                    height: 56,
                    marginBottom: 16,
                    objectFit: "contain",
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  {t(`Dashboard.features.${feature.key}.name`)}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                >
                  {t(`Dashboard.features.${feature.key}.description`)}
                </Typography>
                <Button
                  variant="outlined"
                  color={feature.color}
                  size="small"
                  fullWidth={isMobile}
                  href={`/${feature.url}`}
                >
                  Akses Fitur
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default FeatureComponents;
